import styled from 'styled-components';

import ContentPlaceholder from '@/components/Base/ContentPlaceholder';
import {
  colorGrey50,
  colorWhite,
  mediaQueryLaptopMin,
  mediaQueryMobileLargeMin,
} from '@/styleUtils';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px 16px 24px;
  background: ${colorWhite};

  &:not(:last-of-type) {
    border-bottom: 1px solid ${colorGrey50};
  }

  @media ${mediaQueryMobileLargeMin} {
    padding: 40px 16px 16px;
  }

  @media ${mediaQueryLaptopMin} {
    padding: 40px 16px 44px;
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  @media ${mediaQueryMobileLargeMin} {
    flex-direction: row;
    align-items: center;
  }
`;

export const MainInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  flex-wrap: wrap;

  @media ${mediaQueryMobileLargeMin} {
    flex-direction: row;
    margin-right: 38px;
  }

  @media ${mediaQueryLaptopMin} {
    align-items: start;
    flex-wrap: nowrap;
    margin-right: 32px;
  }
`;

export const LabelPlaceholderWrapper = styled.div`
  flex: 1;
`;

export const LabelPlaceholder = styled(ContentPlaceholder)`
  width: 160px;
  height: 16px;
  margin-bottom: 20px;

  @media ${mediaQueryMobileLargeMin} {
    width: 96px;
    margin-bottom: 12px;
  }

  @media ${mediaQueryLaptopMin} {
    width: 160px;
    margin-bottom: 16px;
  }
`;

export const RatePlaceholder = styled(ContentPlaceholder)`
  width: 88px;
  height: 16px;
  margin-bottom: 16px;

  @media ${mediaQueryMobileLargeMin} {
    width: 64px;
    margin-bottom: 0;
  }

  @media ${mediaQueryLaptopMin} {
    width: 88px;
  }
`;

export const LogoPlaceholderWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;

  @media ${mediaQueryMobileLargeMin} {
    align-items: start;
    flex-direction: column;
  }
`;

export const LogoPlaceholder = styled(ContentPlaceholder)`
  width: 160px;
  height: 32px;
  margin-right: 40px;
  margin-bottom: 16px;

  @media ${mediaQueryMobileLargeMin} {
    width: 96px;
    height: 48px;
    margin-right: 0;
    margin-bottom: 12px;
  }

  @media ${mediaQueryLaptopMin} {
    width: 160px;
    margin-bottom: 16px;
  }
`;

export const MainInfoContent = styled.div`
  display: flex;
  flex: 2;
  margin-bottom: 28px;

  @media ${mediaQueryMobileLargeMin} {
    margin-bottom: 20px;
  }

  @media ${mediaQueryLaptopMin} {
    margin-right: 36px;
    margin-bottom: 0;
  }
`;

export const InfoPlaceholderWrapper = styled.div`
  display: flex;
  flex: 1;

  @media ${mediaQueryMobileLargeMin} {
    flex-direction: column;
  }
`;

export const InfoPlaceholder = styled(ContentPlaceholder)`
  width: 88px;
  height: 44px;

  @media ${mediaQueryMobileLargeMin} {
    height: 48px;
  }
`;

export const BenefitsPlaceholderWrapper = styled.div`
  flex: 1;

  @media ${mediaQueryMobileLargeMin} {
    flex-direction: column;
  }
`;

export const BenefitsPlaceholder = styled(ContentPlaceholder)`
  width: 100%;
  height: 16px;
  margin-bottom: 16px;

  &:last-of-type {
    display: none;
  }

  @media ${mediaQueryMobileLargeMin} {
    &:last-of-type {
      display: block;
    }
  }

  @media ${mediaQueryLaptopMin} {
    width: 240px;
  }
`;

export const ActionPlaceholderWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;

  @media ${mediaQueryMobileLargeMin} {
    align-items: start;
    flex-direction: column;
  }
`;

export const ActionPlaceholder = styled(ContentPlaceholder)`
  width: 192px;
  height: 48px;
  margin-right: 8px;

  @media ${mediaQueryMobileLargeMin} {
    width: 150px;
    margin-right: 0;
    margin-bottom: 12px;
  }

  @media ${mediaQueryLaptopMin} {
    width: 160px;
    margin-bottom: 16px;
  }
`;

export const MoreActionPlaceholder = styled(ContentPlaceholder)`
  width: 88px;
  height: 16px;

  @media ${mediaQueryMobileLargeMin} {
    width: 64px;
    display: block;
    margin: 0 auto;
  }

  @media ${mediaQueryLaptopMin} {
    width: 88px;
  }
`;
